// extracted by mini-css-extract-plugin
module.exports = {"container":"KeywordSearchGroupForAngels_container__35dJq","sending":"KeywordSearchGroupForAngels_sending__2-v-k"};